export const PROJECTS = {
  Web: 'web',
  Mobile: 'mobile',
} as const

// TODO: прокинуть всем установкам cookie
export const sessionCookieName = 'session'
export const phpSessionCookieName = 'PHPSESSID'
export const csrfCookieName = 'X-CSRFToken'
export const csrfHeaderName = 'x-csrf-token'
export const mobileTokenHeaderName = 'x-mobile-token'
export const DEFAULT_REVALIDATE_SECONDS = 60
export const LAYOUT_REVALIDATE_SECONDS = 60

export const BodySelector = 'body#body'

export const ARTICLE_PROPERTY = 'artikul'

export const OAuthProvider = {
  YandexId: 'yandex',
  VK: 'vk',
} as const

export const settings = {
  APP_NAME: 'ru.runlab.mobile',
  DEFAULT_TITLE: 'Магазин Лаборатория бега Runlab | Одежда и обувь для бега',
  DEFAULT_DESCRIPTION:
    'Одежда и обувь для бега, трекинга, триатлона. Подбор кроссовок при помощи видеоанализа. Магазины в Москве и Санкт-Петербурге. Интернет-магазин с доставкой по России.',
  NEXT_PUBLIC_USE_LIGHT_META: process.env.NEXT_PUBLIC_USE_LIGHT_META === 'true',
  OTEL_NAME: `runlab-nextjs-${process.env.NEXT_PUBLIC_APP_ENV ?? 'development'}`,
  OTEL_NAME_MOBILE: `runlab-nextjs-mobile`,
  PROJECT: process.env.NEXT_PUBLIC_PROJECT || '',
  OTEL_CLIENT_ENDPOINT: process.env.NEXT_PUBLIC_OTEL_ENDPOINT,
  OTEL_CLIENT_AUTH_HEADER: process.env.NEXT_PUBLIC_OTEL_AUTH_HEADER,
  NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV || '',
  NEXT_PUBLIC_FRONTEND_URL: process.env.NEXT_PUBLIC_FRONTEND_URL || '',
  NEXT_PUBLIC_WEBAPI_ADDRESS: process.env.NEXT_PUBLIC_WEBAPI_ADDRESS || '',
  NEXT_OAUTH_ADDRESS: process.env.NEXT_OAUTH_ADDRESS || '',
  NEXT_WEBAPI_TOKEN: process.env.NEXT_WEBAPI_TOKEN || '',
  NEXT_PUBLIC_MEDIA_DOMAIN: process.env.NEXT_PUBLIC_MEDIA_DOMAIN || '',
  NEXT_PUBLIC_MEDIA_HOST: process.env.NEXT_PUBLIC_MEDIA_HOST || '',
  NEXT_COOKIE_DOMAIN: process.env.NEXT_COOKIE_DOMAIN || '',
  SESSION_SECRET: process.env.SESSION_SECRET,
  MOBILE_TOKEN: process.env.MOBILE_TOKEN,
  MOBILE_APP_USER: process.env.MOBILE_APP_USER,
  MOBILE_APP_USER_PASSWORD: process.env.MOBILE_APP_USER_PASSWORD,
  MOBILE_APP_JSON_URL: process.env.MOBILE_APP_JSON_URL,
  MOBILE_APP_BASIC_AUTH: process.env.MOBILE_APP_BASIC_AUTH,
  MOBILE_APP_LINK_SECRET: process.env.MOBILE_APP_LINK_SECRET,

  ...(process.env.NEXT_PUBLIC_PROJECT === PROJECTS.Mobile && {
    NEXT_PUBLIC_MOBILE_TOKEN: process.env.NEXT_PUBLIC_MOBILE_TOKEN ?? '',
  }),

  MOCK_AUTH: (process.env.NEXT_PUBLIC_MOCK_AUTH === 'true' && true) || false,
  TIME_ZONE_OFFSET: parseInt(process.env.NEXT_PUBLIC_TIME_ZONE_OFFSET || '3'),
  Y_MAP_API_KEY: process.env.NEXT_PUBLIC_Y_MAP_API_KEY,
  Y_CAPTCHA_KEY: process.env.NEXT_PUBLIC_Y_CAPTCHA_KEY,
  Y_CAPTCHA_SECRET: process.env.NEXT_Y_CAPTCHA_SECRET,
  DADATA_API_KEY: process.env.NEXT_DADATA_API_KEY,
  DIGI_SEARCH_ID: process.env.NEXT_PUBLIC_DIGI_SEARCH_ID,

  REDIRECTED_FROM_QUERY_PARAM: 'redirected_from',

  METRIC_PURCHASE_GOAL_ID: 3017574757,
}
